import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { HttpStatusCode } from "axios";
import { User } from "../../Models/User";
import { Token } from "../../Models/Token";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import Cookies from 'js-cookie';
import { ILoginResponseData } from "../../Interfaces/ResponsesData";


export class AuthVM extends InterActive{
    private accessToken?: Token
    private deviceAuthenticated:boolean = false
    private auth:boolean = false
    private user:User|undefined = undefined

    private loginData:{employee_key:string , password:string , remember:boolean} = {employee_key:'' , password:'', remember:false}
    private deviceLoginData:{password:string} = {password:''}

    public get AccessToken():Token|undefined{ return this.accessToken;}

    public get Auth():boolean { return this.auth }
    public get User():User|undefined { return this.user }
    public get LoginData():{employee_key:string , password:string , remember:boolean}{return this.loginData}
    public get DeviceLoginData():{ password:string }{ return this.deviceLoginData }
    public get DeviceAuth():boolean{ return this.deviceAuthenticated }

    public set Employee_Key(value:string){ this.loginData.employee_key = GeneralMethods.removeNonNumeric(value) ; this.update() }
    public set Password(value:string){ this.loginData.password = value; this.update() }
    public set Remmeber(value:boolean){ this.loginData.remember = value; this.update() }
    public set DevicePassword(value:string){ this.deviceLoginData.password = value; this.update() }

    constructor(){
        super()
        this.checkDevice()
    }

    private checkDevice(){
        const deviceKey = Cookies.get('dev_tkn')
        if(deviceKey){
            this.checkDeviceToken(deviceKey)
        }else {
            this.deviceAuthenticated = false
        }
    }

    public initiate(){
        const ref_tkn = Cookies.get('ref_tkn')
        const ref_exp = Cookies.get('ref_exp')
        const rem_tkn = Cookies.get('rem_tkn') 

        if(ref_tkn && ref_exp){
            if(new Date(ref_exp) > new Date()){
                this.RefreshAuth(ref_tkn)
            }else {
                if(rem_tkn){
                    this.rememberAuth(rem_tkn)
                }else this.failedAuth()
            }
        }else{
            if(rem_tkn){
                this.rememberAuth(rem_tkn)
            }else this.failedAuth()
        }
    }

    public activateDevice(){
        this.loading(
            async()=>{
                this.deviceAuthenticated = false
                try{
                    const response = await ApiRequest.activateDevice(this.deviceLoginData.password)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Cookies.set('dev_tkn',response.data.data.token,  { expires: 365 * 10 } )
                                this.deviceAuthenticated = true
                                this.initiate()
                                this.update()
                            }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                        }else  Notify({type:'danger' , title:'مشكلة' , body:'حدثت مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'مشكلة' , body:'حدثت مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }
    public checkDeviceToken(token:string){
        this.loading(
            async()=>{
                this.deviceAuthenticated = false
                try{
                    const response = await ApiRequest.checkDevice(token)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Cookies.set('dev_tkn',response.data.data.token,  { expires: 365 * 10 })
                                this.deviceAuthenticated = true
                                this.initiate()
                            }
                        }
                    }
                }catch{

                }
            }
        )
    }
    public login(){
        if(this.loginData.employee_key && this.loginData.password){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.Login(this.loginData)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.loginData = {employee_key:'' , password:'' , remember:false}
                                    this.successAuth(response.data.data)
                                }else{
                                    this.failedAuth()
                                    Notify({type:'danger' , title:'البيانات غير صالحة', body:response.data.messege})
                                }
                            }else Notify({type:'danger' , title:'خطأ', body:'خطأ غير معروف1'})
                        }
                    }catch{
                         Notify({type:'danger' , title:'خطأ', body:'خطأ غير معروف2'})
                    }
                }
            )
        }else{
            Notify({type:'danger' , title:'البيانات غير صالحة', body:'يجب ادخال الرقم الوظيفي و كلمة السر'})
        }
    }  
    private RefreshAuth(token:string){
        if(token){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.RefreshLogin(token)
                        if(response?.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.loginData = {employee_key:'' , password:'' , remember:false}
                                this.successAuth(response.data.data)
                            }else{
                                this.failedAuth()
                            }
                        }
                    }catch{
                         
                    }
                }
            )
        }
    }
    private rememberAuth(token:string){
        if(token){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.RememberLogin(token)
                        if(response?.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.loginData = {employee_key:'' , password:'' , remember:false}
                                this.successAuth(response.data.data)
                            }else{
                                this.failedAuth()
                            }
                        }
                    }catch{
                         
                    }
                }
            )
        }
    }

    private failedAuth(){
        this.user = undefined
        this.setToken('access',undefined)
        this.setToken('refresh',undefined)
        this.setToken('remember',undefined)
        this.auth = false
        this.Messege = ''
        this.update()
    }
    private successAuth(data:ILoginResponseData){
        this.user = data.user
        this.setToken('access',data.accessToken)
        this.setToken('refresh',data.refreshToken)
        if(data.remmberToken)this.setToken('remember',data.remmberToken)
        this.auth = true
        this.Messege = ''
        this.update()
    }
    private setToken( type:'access'|'refresh'|'remember',token?:Token ){
        switch (type) {
            case 'access' : {
                this.accessToken = this.formatToken(token)
                break
            }
            case 'refresh' :{
                this.setSessionToken('ref',token)
                break
            }
            case 'remember' :{
                this.setLocalStorageToken('rem',token)
                break
            }
        }
        this.update()
    }

    private formatToken(token?:Token):Token|undefined{
        if(token){
            const tkn:string =  token.token
            var exp:Date|undefined = GeneralMethods.convertToLocalDateTime(token.expiration?.toString())
            return {token:tkn , expiration:exp}
        }
       else return undefined
    }
    private setSessionToken( key:string,token?:Token ){
        token = this.formatToken(token)
        if(token){
            Cookies.set(`${key}_tkn`,token.token);
           if(token.expiration) Cookies.set(`${key}_exp`,token.expiration.toString());
        } else {
            Cookies.remove(`${key}_tkn`);
            Cookies.remove(`${key}_exp`);
        }
    }
    private setLocalStorageToken( key:string,token?:Token ){
        token = this.formatToken(token)
        if(token){
            Cookies.set(`${key}_tkn`,token.token, { expires: token.expiration });
        } else {
            Cookies.remove(`${key}_tkn`);
        }
    }

    public setAccessToken(token:Token){
        this.accessToken = token
        this.update()
    }
    
    public RefreshTokens(access:Token , refresh:Token){
        this.setToken('access',access)
        this.setToken('refresh',refresh)
        this.update()
    }

    public async getToken():Promise<string|undefined>{

        if(this.accessToken && this.accessToken?.expiration && ( this.accessToken?.expiration > new Date() )){
            return this.accessToken.token
        }
        else {
            const ref_tkn = Cookies.get('ref_tkn')
            const ref_exp = Cookies.get('ref_exp') 
            if(ref_tkn && ref_exp && ( new Date(ref_exp) > new Date() )){
                try{
                    const response = await ApiRequest.RefreshLogin(ref_tkn)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.loginData = {employee_key:'' , password:'' , remember:false}
                                this.successAuth(response.data.data)
                            }else{
                                this.failedAuth()
                            }
                        }
                    }
                }catch{
                    Notify({type:'danger',title:'خطأ', body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                } 
            } else {
                Notify({type:'danger',title:'تنبيه', body:'انتهاء صلاحية الجلسة برجاء تسجيل الدخول مرة اخرى'})
                this.failedAuth()
            }
        }
        return this.accessToken?.token
    }

    public authFailure(){
        Notify({type:'danger',title:'خطأ', body:'انتهاء صلاحية الجلسة .. برجاء تسجيل الدخول مرة اخرى'})
        this.failedAuth()
    }
    public deviceFailure(){
        this.deviceAuthenticated = false
        Notify({type:'danger',title:'خطأ', body:'المتصفح لا يملك الصلاحية'})
        this.failedAuth()
    }
    public logout(){
        this.loading(
            async()=>{
                this.failedAuth()
            }
        )
    }
}